import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalHeaderContainer } from "./ModalHeader.style";
import { IconButton } from "../../../../Molecules";
import { Section } from "../../../../Atoms";
export const ModalHeader = ({ title = "success", titleElement = _jsx(_Fragment, {}), onClose = () => { }, }) => {
    return (_jsxs(ModalHeaderContainer, { children: [title && _jsx(Section, { size: "section_2", children: title }), !title && titleElement, _jsx(IconButton, { onClick: onClose, iconName: "itaufonts_fechar", variant: "neutral", weight: "medium" })] }));
};
//# sourceMappingURL=ModalHeader.js.map